// extracted by mini-css-extract-plugin
export default {"truncated":"TruncatedParagraph_truncated__vqHj9"};